import React from 'react'
import { useState } from "react";
import { SlideshowLightbox } from "lightbox.js-react";
import "lightbox.js-react/dist/index.css";

const Anuyalday = () => {
  const [isOpen, setIsOpen] = useState(false);

  const Anuyal_day = [
    {
      src: require("../../../src/images/Annualday/annual.1.jpg"),
    },
    {
      src: require("../../../src/images/Annualday/annual.2.jpg"),
    },
    {
      src: require("../../../src/images/Annualday/annual.3.jpg"),
    },
    {
      src: require("../../../src/images/Annualday/annual.4.jpg"),
    },
    {
      src: require("../../../src/images/Annualday/annual.5.jpg"),
    },
    {
      src: require("../../../src/images/Annualday/annual.6.jpg"),
    },
  ];

  return (
    <div>
      <div className="dlab-img-effect on rotate no-hover">
        <div
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <img
            className="w-100"
            src={require("../../../src/images/Annualday/annual.1.jpg")}
          />
        </div>
        <div className="dlab-info-has p-a20 no-hover ">
          <div className="dlab-post-title">
            <h5 className="post-title" style={{color: "black", backgroundColor: "white", padding: "5px"}}>Annual Day 2020 Celebration</h5>
          </div>
        </div>
      </div>
      <SlideshowLightbox
        theme="lightbox"
        images={Anuyal_day}
        showThumbnails={true}
        open={isOpen}
        lightboxIdentifier="lbox1"
        onClose={() => {
          setIsOpen(false);
        }}
      ></SlideshowLightbox>
    </div>
  )
}

export default Anuyalday